var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveSpecIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 8,
    fill: "#4B9BF5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3157 21.0338C17.6984 23.275 19.65 24.9811 22.0004 24.9811C24.3507 24.9811 26.3024 23.275 26.6851 21.0338H26.7872C27.5567 21.0338 28.1805 20.4099 28.1805 19.6404C28.1805 18.8709 27.5567 18.2471 26.7872 18.2471H26.7535V17.7311C24.8769 17.2881 23.7245 16.2928 23.1324 15.6227C22.2753 16.3885 20.4132 17.6912 17.2474 18.2313L17.0854 18.2532C16.3761 18.318 15.8203 18.9142 15.8203 19.6404C15.8203 20.4099 16.4441 21.0338 17.2136 21.0338H17.3157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2471 16.9226C21.1192 16.2016 22.6724 14.2637 22.6881 14.2436L23.2801 13.4857L23.7561 14.3213C23.7915 14.3816 24.6418 15.7954 26.7531 16.3993V15.753C26.7531 13.128 24.6251 11 22.0001 11C19.3751 11 17.2471 13.128 17.2471 15.753V16.9226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2804 29.1328H28.0796C27.4934 29.1328 27.0166 29.6097 27.0166 30.1958V31.7109H29.3434V30.1958C29.3434 29.6097 28.8665 29.1328 28.2804 29.1328Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8203 31.7109C16.2949 31.7109 16.6797 31.3262 16.6797 30.8516C16.6797 30.3769 16.2949 29.9922 15.8203 29.9922C15.3457 29.9922 14.9609 30.3769 14.9609 30.8516C14.9609 31.3262 15.3457 31.7109 15.8203 31.7109Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5469 26.0683C23.0456 26.2011 22.5259 26.2701 22.0002 26.2701C21.4746 26.2701 20.9549 26.2011 20.4536 26.0683L22.0002 28.2374L23.5469 26.0683Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6715 30.8516C13.6715 29.8914 14.3047 29.0765 15.1754 28.8021V24.9833L13.4165 25.8085C11.9485 26.4972 11 27.9899 11 29.6113V33H15.8199C14.6353 33 13.6715 32.0362 13.6715 30.8516Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5832 25.8085L28.8242 24.9833V27.908C29.8596 28.1542 30.6322 29.0862 30.6322 30.1958V33H32.9997V29.6114C32.9997 27.9899 32.0511 26.4972 30.5832 25.8085Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5359 27.9079V24.3784L26.7217 23.9964C26.5588 24.2005 22.0004 30.4577 22.0004 30.4577C22.0004 30.4577 17.442 24.2006 17.2791 23.9964L16.4648 24.3784V28.8019C17.3356 29.0763 17.9688 29.8913 17.9688 30.8514C17.9688 32.0361 17.005 32.9999 15.8203 32.9999H25.728V30.1957C25.728 29.0861 26.5006 28.1541 27.5359 27.9079Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveSpecIcon);
export default __webpack_public_path__ + "static/media/active-spec-icon.3e963f785947c318a21f3522f97ac5c1.svg";
export { ForwardRef as ReactComponent };